import * as moment from "moment";

// Organize work order chart data
export const returnChartData = (data: any): Array<any> => {
  if (!data || !data.length) {
    return [];
  }

  let chartData: any = [];

  const allMonths = moment.monthsShort();

  // filter workOrders based on month it was created

  // January
  const janworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[0]
  );

  const janData = {
    name: allMonths[0],
    Created: !janworkOrders.length ? 0 : janworkOrders.length,
    Completed: !janworkOrders.length
      ? 0
      : janworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: janworkOrders.length
  };

  chartData = [...chartData, janData];

  // February
  const febworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[1]
  );

  const febData = {
    name: allMonths[1],
    Created: !febworkOrders.length ? 0 : febworkOrders.length,
    Completed: !febworkOrders.length
      ? 0
      : febworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: febworkOrders.length
  };

  chartData = [...chartData, febData];

  // March
  const marworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[2]
  );

  const marData = {
    name: allMonths[2],
    Created: !marworkOrders.length ? 0 : marworkOrders.length,
    Completed: !marworkOrders.length
      ? 0
      : marworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: marworkOrders.length
  };

  chartData = [...chartData, marData];

  // April
  const aprworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[3]
  );

  const aprData = {
    name: allMonths[3],
    Created: !aprworkOrders.length ? 0 : aprworkOrders.length,
    Completed: !aprworkOrders.length
      ? 0
      : aprworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: aprworkOrders.length
  };

  chartData = [...chartData, aprData];

  // May
  const mayworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[4]
  );

  const mayData = {
    name: allMonths[4],
    Created: !mayworkOrders.length ? 0 : mayworkOrders.length,
    Completed: !mayworkOrders.length
      ? 0
      : mayworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: mayworkOrders.length
  };

  chartData = [...chartData, mayData];

  // June
  const junworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[5]
  );

  const junData = {
    name: allMonths[5],
    Created: !junworkOrders.length ? 0 : junworkOrders.length,
    Completed: !junworkOrders.length
      ? 0
      : junworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: junworkOrders.length
  };

  chartData = [...chartData, junData];

  // July
  const julworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[6]
  );

  const julData = {
    name: allMonths[6],
    Created: !julworkOrders.length ? 0 : julworkOrders.length,
    Completed: !julworkOrders.length
      ? 0
      : julworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: julworkOrders.length
  };

  chartData = [...chartData, julData];

  // August
  const augworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[7]
  );

  const augData = {
    name: allMonths[7],
    Created: !augworkOrders.length ? 0 : augworkOrders.length,
    Completed: !augworkOrders.length
      ? 0
      : augworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: augworkOrders.length
  };

  chartData = [...chartData, augData];

  // September
  const sepworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[8]
  );

  const sepData = {
    name: allMonths[8],
    Created: !sepworkOrders.length ? 0 : sepworkOrders.length,
    Completed: !sepworkOrders.length
      ? 0
      : sepworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: sepworkOrders.length
  };

  chartData = [...chartData, sepData];

  // October
  const octworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[9]
  );

  const octData = {
    name: allMonths[9],
    Created: !octworkOrders.length ? 0 : octworkOrders.length,
    Completed: !octworkOrders.length
      ? 0
      : octworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: octworkOrders.length
  };

  chartData = [...chartData, octData];

  // November
  const novworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[10]
  );

  const novData = {
    name: allMonths[10],
    Created: !novworkOrders.length ? 0 : novworkOrders.length,
    Completed: !novworkOrders.length
      ? 0
      : novworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: novworkOrders.length
  };

  chartData = [...chartData, novData];

  // December
  const decworkOrders = data.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("MMM") === allMonths[11]
  );

  const decData = {
    name: allMonths[11],
    Created: !decworkOrders.length ? 0 : decworkOrders.length,
    Completed: !decworkOrders.length
      ? 0
      : decworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: decworkOrders.length
  };

  chartData = [...chartData, decData];

  return chartData;
};

// Organize and return chart data
export const returnWeekChartData = (data: any): Array<any> => {
  if (!data || !data.length) {
    return [];
  }

  let chartData: any = [];

  // Get the current week
  const startOfWeek = moment().startOf("week");
  const endOfWeek = moment().endOf("week");

  const days: any = [];
  let day = startOfWeek;

  while (day <= endOfWeek) {
    days.push(day.toDate());
    day = day.clone().add(1, "d");
  }

  const allWorkOrders = data;

  // filter workOrders based on the day it was created

  // Sunday
  const sunworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[0]).format("DD/MM/YYYY")
  );

  const sunData = {
    name: moment(days[0]).format("ddd"),
    Created: !sunworkOrders.length ? 0 : sunworkOrders.length,
    Completed: !sunworkOrders.length
      ? 0
      : sunworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: sunworkOrders.length
  };

  chartData = [...chartData, sunData];

  // Monday
  const monworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[1]).format("DD/MM/YYYY")
  );

  const monData = {
    name: moment(days[1]).format("ddd"),
    Created: !monworkOrders.length ? 0 : monworkOrders.length,
    Completed: !monworkOrders.length
      ? 0
      : monworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: monworkOrders.length
  };

  chartData = [...chartData, monData];

  // Tuesday
  const tueworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[2]).format("DD/MM/YYYY")
  );

  const tueData = {
    name: moment(days[2]).format("ddd"),
    Created: !tueworkOrders.length ? 0 : tueworkOrders.length,
    Completed: !tueworkOrders.length
      ? 0
      : tueworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: tueworkOrders.length
  };

  chartData = [...chartData, tueData];

  // Wednesday
  const wedworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[3]).format("DD/MM/YYYY")
  );

  const wedData = {
    name: moment(days[3]).format("ddd"),
    Created: !wedworkOrders.length ? 0 : wedworkOrders.length,
    Completed: !wedworkOrders.length
      ? 0
      : wedworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: wedworkOrders.length
  };

  chartData = [...chartData, wedData];

  // Thursday
  const thuworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[4]).format("DD/MM/YYYY")
  );

  const thuData = {
    name: moment(days[4]).format("ddd"),
    Created: !thuworkOrders.length ? 0 : thuworkOrders.length,
    Completed: !thuworkOrders.length
      ? 0
      : thuworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: thuworkOrders.length
  };

  chartData = [...chartData, thuData];

  // Friday
  const friworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[5]).format("DD/MM/YYYY")
  );

  const friData = {
    name: moment(days[5]).format("ddd"),
    Created: !friworkOrders.length ? 0 : friworkOrders.length,
    Completed: !friworkOrders.length
      ? 0
      : friworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: friworkOrders.length
  };

  chartData = [...chartData, friData];

  // Saturday
  const satworkOrders = allWorkOrders.filter(
    (workOrder: any) =>
      moment(workOrder.createdAt).format("DD/MM/YYYY") ===
      moment(days[6]).format("DD/MM/YYYY")
  );

  const satData = {
    name: moment(days[6]).format("ddd"),
    Created: !satworkOrders.length ? 0 : satworkOrders.length,
    Completed: !satworkOrders.length
      ? 0
      : satworkOrders.filter(
          (workOrder: any) => workOrder.status === "COMPLETE"
        ).length,
    amt: satworkOrders.length
  };

  chartData = [...chartData, satData];

  return chartData;
};



// WEBPACK FOOTER //
// ./src/Containers/Reports/WorkOrderCharts/Utils.ts